const USER = 'user'
const OPERATIONS = 'operations'
const ARTICLE = 'article'
const HELP = 'operations/front'
const TERMINAL = 'operations/terminal'
const WHITELIST = 'operations/dataAnalysis/whiteList'
const ACTIVE_CORGANIZATION = `${OPERATIONS}/customerInfo`
export { USER, OPERATIONS, ARTICLE, HELP, TERMINAL, WHITELIST, ACTIVE_CORGANIZATION }
